const SvgTransform1 = (props) => (
  <>
    <path d="M384 0v384H0L384 0z" fill={props.p10} />
  </>
);

export default SvgTransform1;
